import React, { Component } from 'react';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { css } from 'react-emotion';
// First way to import
import { ClipLoader } from 'react-spinners';
import APIService from '../Services/APIService/apiService';
import { Button, Badge } from 'reactstrap';
import {  Redirect } from 'react-router-dom';

const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;

class ExportToFTP extends Component{

    constructor(props){
        super(props);
        this.state = {
            APIName: "ExportFtpPush",
            APIUser: "",
            APIPass: "",
            FtpServer: "",
            FtpPort: "",
            FtpUsername: "",
            FtpPassword: "",
            FtpPath: "",
            ExportSettingField: "",
            loadingExportToFTP: false,
            type: 'password',
            isAutenticated: true
        };
        this.handleApiUser = this.handleApiUser.bind(this);
        this.handleApiPass = this.handleApiPass.bind(this);
        this.handleFtpServer= this.handleFtpServer.bind(this);
        this.handleFtpPort = this.handleFtpPort.bind(this);
        this.handleFtpUsername = this.handleFtpUsername.bind(this);
        this.handleFtpPassword = this.handleFtpPassword.bind(this);
        this.handleFtpPath = this.handleFtpPath.bind(this);
        this.handleExportSettingField = this.handleExportSettingField.bind(this);
        this.showHide = this.showHide.bind(this);
    }  

    showHide(e){
        e.preventDefault();
        e.stopPropagation();
        this.setState({
          type: this.state.type === 'input' ? 'password' : 'input'
        })  
    }
    componentDidMount(){
      
        var ExportToFTPList = this.props.DataExportToFTP;

        var ExportToFTP = ExportToFTPList.find(x=> x.ALIAS === this.state.APIName); 
        var ExportToFTPValue = JSON.parse(ExportToFTP.VALUE);
        var UserName = ExportToFTPValue.EasyApiUser === null || ExportToFTPValue.EasyApiUser === undefined   ? "" :  ExportToFTPValue.EasyApiUser;
        var Pass = ExportToFTPValue.EasyApiPassword === null || ExportToFTPValue.EasyApiPassword === undefined   ? "" :  ExportToFTPValue.EasyApiPassword;
        var FtpServer = ExportToFTPValue.FtpServer === null || ExportToFTPValue.FtpServer === undefined   ? "" :  ExportToFTPValue.FtpServer;
        var FtpPort = ExportToFTPValue.FtpPort === null || ExportToFTPValue.FtpPort === undefined   ? "" :  ExportToFTPValue.FtpPort;
        var FtpUsername = ExportToFTPValue.FtpUsername === null || ExportToFTPValue.FtpUsername === undefined   ? "" :  ExportToFTPValue.FtpUsername;
        var FtpPassword = ExportToFTPValue.FtpPassword === null || ExportToFTPValue.FtpPassword === undefined   ? "" :  ExportToFTPValue.FtpPassword;
        var FtpPath = ExportToFTPValue.FtpPath === null || ExportToFTPValue.FtpPath === undefined   ? "" :  ExportToFTPValue.FtpPath;
        var ExportSettingField = ExportToFTPValue.ExportSettingField === null || ExportToFTPValue.ExportSettingField === undefined   ? "" :  ExportToFTPValue.ExportSettingField;

        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = UserName;
        stateCopy.APIPass = Pass;
        stateCopy.FtpServer = FtpServer;
        stateCopy.FtpPort = FtpPort;
        stateCopy.FtpUsername = FtpUsername;
        stateCopy.FtpPassword = FtpPassword;
        stateCopy.FtpPath = FtpPath;
        stateCopy.ExportSettingField = ExportSettingField;
        this.setState(stateCopy);
    }

    handleApiUser(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIUser = value;
        this.setState(stateCopy);    
    }
    handleApiPass(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.APIPass = value;
        this.setState(stateCopy);    
    }
    handleFtpServer(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpServer = value;
        this.setState(stateCopy);    
    }
    handleFtpPort(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpPort = value;
        this.setState(stateCopy);    
    }
    handleFtpUsername(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpUsername = value;
        this.setState(stateCopy);    
    }
    handleFtpPassword(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpPassword = value;
        this.setState(stateCopy);    
    }
    handleFtpPath(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.FtpPath = value;
        this.setState(stateCopy);    
    }
    handleExportSettingField(event){
        var value = event.target.value;
        let stateCopy = Object.assign({}, this.state);
        stateCopy.ExportSettingField = value;
        this.setState(stateCopy);    
    }
    ValidateSaveExportToFTP(){

        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var FtpServer = this.state.FtpServer;
        var FtpUsername = this.state.FtpUsername;
        var FtpPassword = this.state.FtpPassword;
        var FtpPath = this.state.FtpPath;

        if(UserName === null || UserName === "" || UserName === undefined)
        {
            toast.error("Client API User field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(Pass === null || Pass === "" || Pass === undefined)
        {
            toast.error("Client API Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpServer === null || FtpServer === "" || FtpServer === undefined)
        {
            toast.error("Ftp Server field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpUsername === null || FtpUsername === "" || FtpUsername === undefined)
        {
            toast.error("Ftp Username field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpPassword === null || FtpPassword === "" || FtpPassword === undefined)
        {
            toast.error("Ftp Password field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }
        if(FtpPath === null || FtpPath === "" || FtpPath === undefined)
        {
            toast.error("Ftp Path field can not be empty!", { className: {
                opacity: 0.8
            }});
            return false;
        }   
       
        return true;
    }
   
    SaveExportToFTP(e){
        e.preventDefault();    
        var email = sessionStorage.getItem('email');
        var that = this;
        var UserName = this.state.APIUser;
        var Pass = this.state.APIPass;
        var FtpServer = this.state.FtpServer;
        var FtpPort = this.state.FtpPort;
        var FtpUsername = this.state.FtpUsername;
        var FtpPassword = this.state.FtpPassword;
        var FtpPath = this.state.FtpPath;
        var ExportSettingField = this.state.ExportSettingField;
        var CompanyCode = this.props.CompanyCode;

        var ExportToFTPList = this.props.DataExportToFTP;
        var ExportToFTP = ExportToFTPList.find(x=> x.ALIAS === this.state.APIName);   

        var Validate = this.ValidateSaveExportToFTP();
        if(Validate === false)
        {
            return false;
        }
        this.setState({
            loadingExportToFTP: true
        });

        var result = APIService.SaveExportToFTPSetting(CompanyCode,email, UserName, Pass, FtpServer, FtpPort, FtpUsername, FtpPassword, FtpPath, ExportSettingField);
        result.then(function(data){
            if(data.data === "OK"){
                that.setState({
                    loadingExportToFTP: false
                });
                var newList = {
                    ALIAS: ExportToFTP.ALIAS,
                    COMPANY_CODE: CompanyCode,
                    ID: ExportToFTP.ID,
                    NAME: ExportToFTP.NAME,
                    VALUE: {
                        EasyApiUser: UserName,
                        EasyApiPassword: Pass,
                        FtpServer:FtpServer,
                        FtpPort: FtpPort,
                        FtpUsername: FtpUsername,
                        FtpPassword: FtpPassword,
                        FtpPath:FtpPath,
                        ExportSettingField: ExportSettingField,
                        Name:ExportToFTP.ALIAS
                    }
                };
                that.props.SetObject(newList);
                toast.success("Saved!", { className: {
                    opacity: 0.8
                }});            
            }else if(data.data === "Invalid_ExportSetting"){
                that.setState({
                    loadingExportToFTP: false
                });  
                toast.error("Invalid ExportSetting Field!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "NoExist"){
                that.setState({
                    loadingExportToFTP: false
                });  
                toast.error("API Setting dosen't exist!", { className: {
                    opacity: 0.8
                }});
            }else if(data.data === "Empty"){
                that.setState({
                    loadingExportToFTP: false
                });                
                toast.error("Not Exist!", { className: {
                    opacity: 0.8
                }});
            }
        }).catch((error) => {

            that.setState({
                loadingExportToFTP: false,
            });      
            if(error.response)
            {
                if(error && error.response && error.response.data.Message === "500") {               
                    toast.error("Error Data Base(Error: 500)", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NoDB") {
                   toast.error("Company Code dosen't exist!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data === "NotReseller") {    
                   toast.error("This User does not have permission!", { className: {
                       opacity: 0.8
                   }});
               }else if(error && error.response && error.response.data.Message === "400"){ 
                   toast.error("API Error for Reseller", { className: {
                       opacity: 0.8
                   }});
                }else if(error.response.status === 401){ 
                       sessionStorage.setItem("user", '');
                       sessionStorage.setItem("token", '');
                       sessionStorage.setItem("rol", '');
                       sessionStorage.setItem("email", '');
                       sessionStorage.clear();  
                       this.setState({ isAutenticated: false },
                       ()=>{                               
                           this.forceUpdate();
                       })              
                }   
            }else{
                toast.error("Code Error", { className: {
                    opacity: 0.8
                }});
            }
        });        
    }   
    render(){      
        
        if (!this.state.isAutenticated) {
            return (<Redirect to={'/login'}/>)
        }

        return (
            <div>
                <div className="card Logs"><ToastContainer hideProgressBar/>
                    <div className="card-body" style={{ height: "600px", 'overflowY': 'scroll'}}>
                        <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Name</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="name" id="name" type="text" value={ this.state.APIName} readOnly/>
                            </div>                          
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API User</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="apiuser" id="apiuser" type="text" onChange={this.handleApiUser}  value={ this.state.APIUser}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Client API Password</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="apipass" id="apipass" type={this.state.type} onChange={this.handleApiPass }   value={ this.state.APIPass}/>
                            </div>    
                            <div className="col-2" style={{ 'paddingTop': '15px' }}>                                
                                <Badge color="default" style={{ 'cursor': 'pointer'}} className="password__show" onClick={this.showHide}>{this.state.type === 'input' ? 'Hide' : 'Show'}</Badge>
                            </div>                      
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>FTP Server(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpServer" id="FtpServer" type="text" onChange={this.handleFtpServer}  value={ this.state.FtpServer}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>FTP Port</label>
                            </div>   
                            <div className="col-2">
                                <input type="number" style={{ 'marginTop': '10px' }} className="form-control" name="FtpPort" id="FtpPort"  onChange={this.handleFtpPort }   value={ this.state.FtpPort}/>
                            </div>                         
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>FTP Username(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpUsername" id="FtpUsername" type="text" onChange={this.handleFtpUsername}  value={ this.state.FtpUsername}/>
                            </div>  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>FTP Password(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2">
                                <input style={{ 'marginTop': '10px' }} className="form-control" name="FtpPassword" id="FtpPassword" type="text" onChange={this.handleFtpPassword }   value={ this.state.FtpPassword}/>
                            </div>                           
                       </div>
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>
                       <div className="row">
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>FTP Path(<span style={{color: 'red'}}>*</span>):</label>
                            </div>   
                            <div className="col-2" style={{ marginRight: "100px" }}>
                                <input style={{ 'marginTop': '10px'}} className="form-control" name="FtpPath" id="FtpPath" type="text" onChange={this.handleFtpPath } value={ this.state.FtpPath}/>
                            </div>                          
                       </div>                      
                       <hr style={{ color: "#E0E0E0", backgroundColor: "#E0E0E0", height: 1}}/>                      
                       <div className="row">  
                            <div className="col-2 ">
                                <label className="control-label" style={{ 'paddingTop': '15px','fontWeight': 'bold' }}>Export Settings</label>
                            </div>   
                            <div className="col-6" style={{ marginRight: "100px" }}>
                                <textarea style={{ 'marginTop': '10px'}} className="form-control" name="ExportSettingField" id="ExportSettingField" rows="5" onChange={this.handleExportSettingField} value={ this.state.ExportSettingField}></textarea>
                            </div>               
                       </div>
                       <div className="row">
                            <div className="col-2 offset-10"  size="sm" >
                                        <ClipLoader
                                            className={override}
                                            sizeUnit={"px"}
                                            size={30}
                                            color={'#33B5E5'}
                                            loading={this.state.loadingExportToFTP}
                                        />
                                        {
                                            this.state.loadingExportToFTP
                                            ?
                                            <Button   color="info" tag="a" onClick={(e)=>this.SaveExportToFTP(e)} disabled>Save</Button>
                                            : 
                                            <Button   color="info" tag="a" onClick={(e)=>this.SaveExportToFTP(e)}>Save</Button>
                                        }
                                    
                            </div>                          
                       </div>  
                   </div>
                </div>
            </div>            
        );
    }
}

export default ExportToFTP;


// WEBPACK FOOTER //
// ./src/APIComponent/ExportToFTP.jsx